<template>
  <div class="list">
    <div class="title" :id="'heading' + _uid">
      <slot name="headline"></slot>
    </div>
    <div :id="'list' + _uid" :aria-labelledby="'heading' + _uid">
      <div class="itemised-bill-table">
        <div class="row header">
          <div class="col bill_col1"><slot name="col1Header">Datum</slot></div>
          <div class="col bill_col2"><slot name="col2Header">Uhrzeit</slot></div>
          <div class="col bill_col3" v-if="hasDestination"><slot name="col3Header">Rufnummer</slot></div>
          <div class="col bill_col4" v-if="hasDuration"><slot name="col4Header">Dauer</slot></div>
          <div class="col bill_col3" v-if="!hasDestination && !hasDuration"><slot name="col3Header">Bemerkung</slot></div>
          <div class="col bill_col5">
            <slot v-if="groupType === 'topUpAndVoucher'" name="col5TopupHeader">Betrag</slot>
            <slot v-else name="col5Header">Kosten</slot>
          </div>
        </div>
        <div class="row body" v-for="bill in getItemisedBillsExtra" :key="bill.id">
          <div class="col bill_col1">
            <dyn-slot :slot-data="bill" :hideParentEnvironment="false">
              <slot name="col1Content"><span class="d-inline-block d-md-none bold-font">Datum: </span> {{ dateFormatter(bill.actionDate) }}</slot>
            </dyn-slot>
          </div>
          <div class="col bill_col2">
            <dyn-slot :slot-data="bill" :hideParentEnvironment="false">
              <slot name="col2Content"><span class="d-inline-block d-md-none bold-font">Uhrzeit: </span> {{ timeFormatter(bill.actionDate) }}</slot>
            </dyn-slot>
          </div>
          <div class="col bill_col3" v-if="hasDestination">
            <dyn-slot :slot-data="bill" :hideParentEnvironment="false">
              <slot name="col3Content"><span class="d-inline-block d-md-none bold-font">Rufnummer: </span> {{ bill.destination }}</slot>
            </dyn-slot>
          </div>
          <div class="col bill_col3" v-if="!(hasDestination || hasDuration)">
            <dyn-slot :slot-data="bill" :hideParentEnvironment="false">
              <slot name="col3Content"><span class="d-inline-block d-md-none bold-font">Bemerkung: </span> {{ bill.description }}</slot>
            </dyn-slot>
          </div>
          <div class="col bill_col4" v-if="hasDuration">
            <dyn-slot :slot-data="bill" :hideParentEnvironment="false">
              <slot name="col4Content"><span class="d-inline-block d-md-none bold-font">Dauer: </span> {{ (bill.duration) }}</slot>
            </dyn-slot>
          </div>
          <div class="col bill_col5">
            <dyn-slot :slot-data="bill" :hideParentEnvironment="false">
              <slot name="col5Content"><span class="d-inline-block d-md-none color-blue">Kosten: </span> <span class="color-blue">{{ price(bill.value) }}</span></slot>
            </dyn-slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import price from '@/mixins/price'

export default {
  name: 'ItemisedBillingList',
  computed: {
    getItemisedBillsExtra () {
      const itemisedBillsExtra = this.itemisedBills
      itemisedBillsExtra.forEach((bill) => {
        bill.description = this.extraData.description[bill.groupKey] || ''
      })
      return itemisedBillsExtra
    },
    sum () {
      return this.itemisedBills.reduce(function (pv, cv) {
        return pv + parseInt(cv.value)
      }, 0)
    },
    hasDestination () {
      let billsWithDestination = this.itemisedBills
      billsWithDestination = billsWithDestination.filter((bill) => {
        return bill?.destination || false
      })
      return billsWithDestination?.length !== 0
    },
    hasDuration () {
      let billsWithDuration = this.itemisedBills
      billsWithDuration = billsWithDuration.filter((bill) => {
        return bill?.duration || false
      })
      return billsWithDuration?.length !== 0
    }
  },
  props: {
    groupType: {
      type: String,
      default: 'normal'
    },
    itemisedBills: {
      type: Array,
      default: () => []
    },
    tag: {
      type: String,
      default: 'h5'
    },
    show: {
      type: Boolean,
      default: false
    },
    extraData: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [
    price
  ],
  methods: {
    dateFormatter (date) {
      const d = new Date(date)
      const year = d.getFullYear()
      const century = Math.floor(year / 100)
      const rest = year % 100

      return this.makeTwoDigits(d.getDate()) + '.' +
        this.makeTwoDigits(d.getMonth() + 1) + '.<span class="century">' +
        this.makeTwoDigits(century) + '</span>' + this.makeTwoDigits(rest)
    },
    timeFormatter (date) {
      const d = new Date(date)
      const h = d.getHours()
      const m = d.getMinutes()
      const s = d.getSeconds()

      return this.makeTwoDigits(h) + ':' +
        this.makeTwoDigits(m) + '<span class="seconds">:' +
        this.makeTwoDigits(s) + '</span>'
    },
    dateTimeFormatter (date) {
      return this.$config.calendar.formatter.dateTimeFormatter.format(new Date(date))
    },
    makeTwoDigits (n) {
      return n > 9 ? '' + n : n < 100 ? '0' + n : '' + n
    }
  }
}
</script>
